define('OutSystems/ClientRuntime/Performance',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.clear = exports.dump = exports.end = exports.start = void 0;
    var COLLECT = typeof __PERFORMANCE !== "undefined";
    function start(sectionName) {
        if (COLLECT) {
            __PERFORMANCE.start(sectionName);
        }
    }
    exports.start = start;
    function end(sectionName) {
        if (COLLECT) {
            __PERFORMANCE.end(sectionName);
        }
    }
    exports.end = end;
    function dump() {
        if (COLLECT) {
            return __PERFORMANCE.dump();
        }
    }
    exports.dump = dump;
    function clear() {
        if (COLLECT) {
            return __PERFORMANCE.clear();
        }
    }
    exports.clear = clear;
});
//# sourceMappingURL=Performance.js.map;
